var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcculockKeySoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Acculock_key_software"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Acculock_key_software",
    "data-name": "Acculock key software",
    clipPath: "url(#clip-Acculock_key_software)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_0",
    transform: "translate(0.985 -2.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M58.494,53.923H55.108c-7.024-5.237-8.2-7.844-7.066-10.768H28.42c1.115,2.923-.063,5.531-7.087,10.768H17.968a2.1,2.1,0,1,0,0,4.206H58.494a2.1,2.1,0,0,0,0-4.206Z",
    transform: "translate(10.865 44.596)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M86.415,11.815H76.32A10.268,10.268,0,0,1,78.654,17.6h4.29a1.9,1.9,0,0,1,1.914,1.893V59.029H13.334V19.491A1.9,1.9,0,0,1,15.247,17.6H26.015l-2.881-2.545,3.68-3.239H11.8a5.776,5.776,0,0,0-5.783,5.762c0,.061,0,.114,0,.167,0-.008,0-.016,0-.024,0,.014,0,.027,0,.043v.143q0,.074,0,.167c0-.02,0-.04,0-.061,0,.039,0,.077,0,.109,0,.065,0,.112,0,.152v.046c0,2.6.006,13.113.021,49.458a5.749,5.749,0,0,0,5.741,5.741H86.394a5.753,5.753,0,0,0,5.762-5.741c.005-12.145.021-49.868.021-50.2a5.771,5.771,0,0,0-5.762-5.762ZM40.4,69.439a2.1,2.1,0,1,1-.021-4.206H40.4a2.1,2.1,0,0,1,0,4.206Zm8.707,0a2.1,2.1,0,1,1-.021-4.206h.021a2.1,2.1,0,1,1,0,4.206Zm8.707,0a2.1,2.1,0,1,1-.021-4.206h.021a2.1,2.1,0,0,1,0,4.206Z",
    transform: "translate(0 10.027)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M14.4,53.414A10.824,10.824,0,0,0,25.21,64.245h.021A10.842,10.842,0,0,0,36.062,53.414a10.729,10.729,0,0,0-5.867-9.59V9.313L25.231,3.277,20.247,9.313l4.311,3.807L20.247,16.9l4.311,3.785-4.311,3.785,4.311,3.807-4.311,3.785V43.824a11.072,11.072,0,0,0-2.692,1.935A10.918,10.918,0,0,0,14.4,53.414Z",
    transform: "translate(9.249 0.609)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M26.878,20.344H41.7a6.217,6.217,0,1,0-.021-4.206H26.878a2.1,2.1,0,0,0,0,4.206Z",
    transform: "translate(20.693 10.225)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M26.878,21.842h6.814a5.655,5.655,0,0,0,5.657-5.636V14.839a6.246,6.246,0,1,0-4.206,0v1.367a1.436,1.436,0,0,1-1.451,1.43H26.878a2.1,2.1,0,0,0,0,4.206Z",
    transform: "translate(20.693 0)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M26.878,22.311h6.814a1.45,1.45,0,0,1,1.451,1.43v1.367a6.246,6.246,0,1,0,4.206,0V23.741a5.654,5.654,0,0,0-5.657-5.636H26.878a2.1,2.1,0,0,0,0,4.206Z",
    transform: "translate(20.693 16.965)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcculockKeySoftware);
export default __webpack_public_path__ + "static/media/acculock-key-software.8e2f43076782dad6902f0b170a00aa98.svg";
export { ForwardRef as ReactComponent };